import React from 'react';
import TextCheckBox from 'components/shared/TextCheckBox';

const TextCheckboxTableRow = ({
  text,
  selectedTextsForRevision,
  deploymentQueue,
  setDeploymentQueue,
  setSelectedTextsForRevision,
  isEligibleForRevision,
  isAwaitingDeployment,
  availableRevisionNumber,
}) => {
  return (
    <td>
      <TextCheckBox
        text={text}
        selectionHandlers={{
          selectedTextsForRevision,
          setSelectedTextsForRevision,
          deploymentQueue,
          setDeploymentQueue,
        }}
        eligibility={{
          isEligibleForRevision,
          isAwaitingDeployment,
          availableRevisionNumber,
        }}
      />
    </td>
  );
};

export default TextCheckboxTableRow;
